'use strict';

export default FormData;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/FormData.js
// module id = 161
// module chunks = 0